import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAwesome = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M12.6665 6.00033L13.4998 4.16699L15.3332 3.33366L13.4998 2.50033L12.6665 0.666992L11.8332 2.50033L9.99984 3.33366L11.8332 4.16699L12.6665 6.00033Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.6665 10.0003L11.8332 11.8337L9.99984 12.667L11.8332 13.5003L12.6665 15.3337L13.4998 13.5003L15.3332 12.667L13.4998 11.8337L12.6665 10.0003Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.6665 6.33366L5.99984 2.66699L4.33317 6.33366L0.666504 8.00033L4.33317 9.66699L5.99984 13.3337L7.6665 9.66699L11.3332 8.00033L7.6665 6.33366ZM6.65984 8.66033L5.99984 10.1137L5.33984 8.66033L3.8865 8.00033L5.33984 7.34033L5.99984 5.88699L6.65984 7.34033L8.11317 8.00033L6.65984 8.66033Z",
			fill: "currentColor"
		})
	]
});
export { SvgAwesome as ReactComponent };
